<template>
  <div class="cpm-wrapper">
    <el-dialog title="选择发票" :visible.sync="dialogVisible" width="630px" :close-on-click-modal="false">
      <div class="cpm-content">
        <div class="choose-invoice">
          <div class="page-attention">
            电子发票，功效等同于普通纸质发票。增值税电子普通发票的开票方和受票方需要纸质发票的，可以自行打印增值税电子普通发票的版式文件，其法律效力、基本用途、基本使用规定等与税务机关监制的增值税普通发票相同。
          </div>
          <div class="types">
            <template v-for="item in switchBtn">
              <span
                @click="changeType(item._v)"
                :class="['pointer type-item', type === item._v ? 'type-item-active' : '']"
              >
                {{ item.name }}
              </span>
            </template>
            <!--            <span @click="changeType(1)" :class="['pointer type-item', type === 1 ? 'type-item-active' : '']">-->
            <!--              专用发票-->
            <!--            </span>-->
            <!--            <span @click="changeType(2)" :class="['pointer type-item', type === 2 ? 'type-item-active' : '']">-->
            <!--              普通发票-->
            <!--            </span>-->
          </div>
          <div class="page-invoice-type">
            <h2 class="page-h2">发票类型</h2>
          </div>
          <div class="form-content">
            <el-form v-show="type === 2" ref="form" :rules="rules" :model="form" label-width="150px">
              <el-form-item prop="name" label="公司名称">
                <el-input
                  size="mini"
                  v-if="mode === 'edit'"
                  :disabled="formData.name !== ''"
                  v-model="form.name"
                ></el-input>
                <span v-else>{{ form.name }}</span>
                <HintIcon tip="普票要求的公司名称" />
              </el-form-item>
              <el-form-item prop="taxNo" label="纳税人识别号">
                <el-input
                  size="mini"
                  v-if="mode === 'edit'"
                  :disabled="formData.taxNo !== ''"
                  v-model="form.taxNo"
                ></el-input>
                <span v-else>{{ form.taxNo }}</span>
                <HintIcon tip="营业执照上的统一社会信用代码" />
              </el-form-item>
              <el-form-item prop="mailbox" label="收票人邮箱(电子邮箱)">
                <el-input size="mini" v-if="mode === 'edit'" v-model="form.mailbox"></el-input>
                <span v-else>{{ form.mailbox }}</span>
                <HintIcon tip="用于接受电子发票" />
              </el-form-item>
              <el-form-item v-if="mode === 'view'">
                <el-button style="border-radius: 0" type="primary" @click="mode = 'edit'">编辑</el-button>
              </el-form-item>
            </el-form>
            <el-form
              v-show="type === 1"
              ref="formSpecial"
              :rules="rulesSpecial"
              :model="formSpecial"
              label-width="150px"
            >
              <el-form-item prop="name" label="公司名称">
                <el-input
                  size="mini"
                  v-if="mode === 'edit'"
                  :disabled="formSpecialData.name !== ''"
                  v-model="formSpecial.name"
                ></el-input>
                <span v-else>{{ formSpecial.name }}</span>
                <HintIcon tip="专票要求的公司名称" />
              </el-form-item>
              <el-form-item prop="taxNo" label="纳税人识别号">
                <el-input
                  size="mini"
                  v-if="mode === 'edit'"
                  :disabled="formSpecialData.taxNo !== ''"
                  v-model="formSpecial.taxNo"
                ></el-input>
                <span v-else>{{ formSpecial.taxNo }}</span>
                <HintIcon tip="营业执照上的统一社会信用代码" />
              </el-form-item>
              <el-form-item prop="address" label="公司地址">
                <el-input
                  size="mini"
                  v-if="mode === 'edit'"
                  :disabled="formSpecialData.address !== ''"
                  v-model="formSpecial.address"
                ></el-input>
                <span v-else>{{ formSpecial.address }}</span>
                <HintIcon tip="专票要求的公司地址" />
              </el-form-item>
              <el-form-item prop="openBank" label="开户银行">
                <el-input
                  size="mini"
                  v-if="mode === 'edit'"
                  :disabled="formSpecialData.openBank !== ''"
                  v-model="formSpecial.openBank"
                ></el-input>
                <span v-else>{{ formSpecial.openBank }}</span>
                <HintIcon tip="例：建设银行中山支行" />
              </el-form-item>
              <el-form-item prop="bankAccount" label="银行账号">
                <el-input
                  size="mini"
                  v-if="mode === 'edit'"
                  :disabled="formSpecialData.bankAccount !== ''"
                  v-model="formSpecial.bankAccount"
                ></el-input>
                <span v-else>{{ formSpecial.bankAccount }}</span>
                <HintIcon tip="开户许可证或法人的私人账户" />
              </el-form-item>
              <el-form-item prop="phone" label="公司电话">
                <el-input size="mini" v-if="mode === 'edit'" v-model="formSpecial.phone"></el-input>
                <span v-else>{{ formSpecial.phone }}</span>
                <HintIcon tip="专票要求的公司电话" />
              </el-form-item>
              <el-form-item v-if="mode === 'view'">
                <el-button style="border-radius: 0" type="primary" @click="mode = 'edit'">编辑</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div slot="footer" style="textalign: right">
        <el-button style="border-radius: 0" @click="onCancel">取消</el-button>
        <el-button style="border-radius: 0" type="primary" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import * as api from '@/services';
import { mapActions, mapState } from 'vuex';
import HintIcon from '@/components/HintIcon';
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    HintIcon
  },
  computed: {
    ...mapState('order', ['preOrderInfo'])
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          // this.getInvoice({ invoiceType: this.type });
          this.loadInvoiceData();
        }
      }
    }
  },
  mounted() {},
  data() {
    var validatorPhone = (rule, val, callback) => {
      var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
      var isMob = /^1\d{10}$/;
      if (isMob.test(val) || isPhone.test(val)) {
        callback();
      } else {
        callback(new Error('请输入正确的电话'));
      }
    };
    return {
      mode: 'edit',
      dialogVisible: false,
      type: 1,
      imageUrl: '',
      formData: {},
      formSpecialData: {},
      form: {
        name: '',
        taxNo: '',
        mailbox: ''
      },
      formSpecial: {
        name: '',
        taxNo: '',
        address: '',
        phone: '',
        openBank: '',
        bankAccount: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        taxNo: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        mailbox: [{ required: false }]
      },
      rulesSpecial: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        taxNo: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入公司地址', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入公司电话', trigger: 'blur' },
          { validator: validatorPhone, trigger: 'blur' }
        ],
        openBank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' },
          { min: 1, max: 50, message: '最多50个字符', trigger: 'blur' }
        ]
      },
      switchBtn: [
        {
          _v: 1,
          name: '专用发票'
        },
        {
          _v: 2,
          name: '普通发票'
        }
      ]
    };
  },

  methods: {
    ...mapActions('order', ['setPreOrderInfo']),
    async loadInvoiceData() {
      // 增加个按需显示发票类型按钮
      this.switchBtn = [
        {
          _v: 1,
          name: '专用发票'
        },
        {
          _v: 2,
          name: '普通发票'
        }
      ];
      const invoiceData1 = await api.personal.getInvoiceDetail({ invoiceType: 1 });
      const invoiceData2 = await api.personal.getInvoiceDetail({ invoiceType: 2 });
      if (!invoiceData1 && invoiceData2) {
        this.type = 2;
        this.form = invoiceData2;
        this.formData = cloneDeep(this.form);
        this.switchBtn = [
          {
            _v: 2,
            name: '普通发票'
          }
        ];
      }
      if (!invoiceData2 && invoiceData1) {
        this.switchBtn = [
          {
            _v: 1,
            name: '专用发票'
          }
        ];
        this.type = 1;
        this.formSpecial = invoiceData1;
        this.formSpecialData = cloneDeep(this.formSpecial);
      }
      if (invoiceData2 && invoiceData1) {
        //都存在就显示专票
        this.type = 1;
        this.formSpecial = invoiceData1;
        this.formSpecialData = cloneDeep(this.formSpecial);
      }
      console.log(invoiceData1, invoiceData2);
    },
    getInvoice(params) {
      api.personal.getInvoiceDetail(params).then((res = {}) => {
        if (this.type === 2) {
          this.form = res;
          this.formData = cloneDeep(this.form);
        }
        if (this.type === 1) {
          this.formSpecial = res;
          this.formSpecialData = cloneDeep(this.formSpecial);
        }
      });
    },
    async saveInvoice(invoiceInfo) {
      if (this.type === 2 && invoiceInfo.mailbox && !invoiceInfo.mailbox.includes('@')) {
        this.$message('请输入正确的邮箱地址');
        return;
      }
      await api.personal.modifyInvoice({ ...invoiceInfo, invoiceType: this.type });
      this.$message.success('提交成功');
      if (!invoiceInfo.invoiceId) {
        const invoice = await api.personal.getInvoiceDetail({ invoiceType: this.type });
        this.setOrderInvoice(invoice.invoiceId, invoiceInfo.name);
      } else {
        this.setOrderInvoice(invoiceInfo.invoiceId, invoiceInfo.name);
      }
      // this.mode = 'view';
    },
    setOrderInvoice(invoiceId, name) {
      let type = '专用发票';
      if (this.type === 2) {
        type = '普通发票';
      }
      if (this.type === 1) {
        type = '专用发票';
      }
      this.setPreOrderInfo({
        ...this.preOrderInfo,
        invoiceId: invoiceId,
        invoiceType: type,
        invoiceName: name
      });
      this.dialogVisible = false;
    },
    changeType(val) {
      this.type = val;
      // this.mode = 'view';
      if (val === 1) {
        this.$refs.formSpecial.resetFields();
      } else {
        this.$refs.form.resetFields();
      }
      this.getInvoice({ invoiceType: this.type });
    },
    submitForm() {
      const formName = this.type === 1 ? 'formSpecial' : 'form';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveInvoice(this.type === 1 ? this.formSpecial : this.form);
        } else {
          return false;
        }
      });
    },
    onCancel() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  margin-bottom: 8px;
}
.cpm-wrapper {
  ::v-deep .el-input__inner {
    border-radius: 0;
  }
  ::v-deep .el-form-item__content {
    width: 328px;
    display: flex;
  }
  .cpm-content {
    .page-title {
      font-size: 24px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 24px;
    }
    .page-h2 {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 14px;
    }
    .page-attention {
      width: 100%;
      height: 78px;
      background: #fffbe6;
      border: 1px solid #ffe58f;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 18px;
      padding: 12px;
    }
    .page-invoice-type {
      .invoice-wrapper {
        margin-top: 16px;
        margin-bottom: 24px;
      }
    }
    .types {
      width: 436px;
      margin: 16px 0;
      // padding-left: 150px;
      .type-item {
        display: inline-block;
        width: 184px;
        height: 32px;
        border: 1px solid #dedede;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 32px;
        margin-right: 8px;
        text-align: center;
        background-color: #fafafa;
      }
      .type-item-active {
        border: 1px solid #1e8dff;
        background-color: #ffffff;
        color: #1e8dff;
        background: #fff url('../../../assets/img/trian-right-icon.png') right bottom no-repeat;
        background-size: 17px 17px;
      }
    }
  }
}
</style>
